/* eslint-disable */
import styled from 'styled-components'
import tokens from '../tokens'

const { fonts } = tokens

export default styled.div`
  display: flex;

  @media screen and (min-width: 300px) and (max-width: 767px) {
    display: inline-block;
    text-align: center;
    padding: 24px;
  }

  height: 100%;
  width: 100%;
  flex-direction: row;
  align-items: flex-start;
  border-radius: 20px;
  box-shadow: 0 10px 10px 0
    ${props => props.shadow || 'rgba(143, 116, 255, 0.05)'};
  border: solid 1px ${props => props.border || '#e3dbff'};
  background-color: #ffffff;
  padding: ${props => props.padding};
  transition: all 0.3s ease-in;
  &:hover {
    box-shadow: ${props =>
      props.hover ? '0 8px 20px 0 rgba(29, 29, 29, 0.6)' : 'unset'};
    transition: all 0.3s ease-in;
  }
  .card-long-image {
    width: ${props => (props.imageAuto ? 'auto' : props.imageSize)};
    height: auto;
    object-fit: contain;
  }
  .text {
    width: ${props => `calc(100% - ${props.imageSize || 0})`};
    padding-left: 20px;
  }
  h4 {
    font-family: ${fonts.fontFamilyBasic};
    font-size: 24px;
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #555555;
    margin: 0 0 10px 0;
  }
  p {
    font-family: ${fonts.fontFamilyBasic};
    font-size: 18px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.61;
    letter-spacing: normal;
    color: #888888;
    margin: 0;
  }
  @media screen and (min-width: 300px) and (max-width: 768px) {
    .card-long-image {
      width: 60px !important;
      height: 60px;
    }
    .text {
      padding-left: 0;
      width: 100%;
    }
  }
`
